// Module
var code = "<customs-codes></customs-codes>\n";
// Exports
module.exports = code;